import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: '¿Es una dieta estricta?',
    a: 'No. Es un protocolo de desinflamación. Vas a aprender qué alimentos disparan tu cortisol y cuáles te ayudan a bajarlo, sin pasar hambre.'
  }, {
    q: '¿En cuánto tiempo veo resultados?',
    a: 'La mayoría de las personas notan una reducción en la hinchazón abdominal y mejoras en el sueño durante los primeros 7 a 14 días.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'Inmediatamente después del pago, recibís un mail con acceso a todo el contenido digital en formato PDF, listo para descargar en tu celular o compu.'
  }, {
    q: '¿Sirve si tengo poco tiempo?',
    a: '¡Totalmente! Está diseñado para personas que viven a mil. Las rutinas toman menos de 15 minutos al día.'
  }];
  const [openIdx, setOpenIdx] = useState<number | null>(0);
  return <section className="px-4 py-10 max-w-md mx-auto" data-id="element-16">
      <h2 className="text-2xl font-bold text-darkslate mb-6 text-center" data-id="element-17">
        Preguntas Frecuentes
      </h2>

      <div className="space-y-3" data-id="element-18">
        {faqs.map((faq, idx) => <div key={idx} className="bg-white rounded-2xl border border-gray-200 overflow-hidden transition-all" data-id="element-19">
            <button onClick={() => setOpenIdx(openIdx === idx ? null : idx)} className="w-full px-5 py-4 text-left flex justify-between items-center font-semibold text-darkslate text-sm" data-id="element-20">
              {faq.q}
              <ChevronDown className={`w-5 h-5 text-sage-dark transition-transform ${openIdx === idx ? 'rotate-180' : ''}`} data-id="element-21" />
            </button>

            {openIdx === idx && <div className="px-5 pb-4 text-sm text-gray-600 border-t border-gray-100 pt-3" data-id="element-22">
                {faq.a}
              </div>}
          </div>)}
      </div>
    </section>;
}